module.exports = __webpack_public_path__ + "static/media/wizard-instance.533bfcaf.png";